import logoIcon from "./assets/logo-icon-mono.png";
import logoFull from "./assets/logo-full.png";

export const LOGO_URL = logoIcon;
export const LOGO_FULL = logoFull;

export const IMG = {
  hero: "https://images.unsplash.com/photo-1718152421680-d1580e843cc9?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  commercial:
    "https://images.unsplash.com/photo-1497366754035-f200968a6e72?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  industrial:
    "https://images.unsplash.com/photo-1767294274634-613a3545e36d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  basel:
    "https://images.unsplash.com/photo-1700132965327-939c6f6338d2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  gallery: [
    "https://images.unsplash.com/photo-1767294274634-613a3545e36d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    "https://images.pexels.com/photos/1098982/pexels-photo-1098982.jpeg?auto=compress&cs=tinysrgb&w=1000",
    "https://images.unsplash.com/photo-1497366811353-6870744d04b2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    "https://images.unsplash.com/photo-1513828742140-ccaa28f3eda0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  ],
};

export const CONTACT = {
  address: "Waldeckstrasse 5",
  city: "4053 Basel",
  country: "Schweiz",
  phone: "+41 16082621305",
  email: "info@spcleaning.ch",
};
